var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cssClass,on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit('click')}}},[(false === _vm.isPlayNow)?_vm._t("play"):_vm._t("stop")],2)}
var staticRenderFns = []

export { render, staticRenderFns }